/*
 * <filters-toggle> – shows/hides the desktop filter sidebar on collection and search pages and
 * remembers the choice (localStorage). Labels: data-label-show / data-label-hide.
 */
if (!customElements.get("filters-toggle")) {
  customElements.define(
    "filters-toggle",
    class FiltersToggle extends HTMLElement {
      static STORAGE_KEY = "_SIDEBAR_COLLAPSED_KEY_";

      connectedCallback() {
        const scope = this.closest("facet-filters-form") || document;
        this.toggleButton = this.querySelector(".button-collection-filters-toggle");
        this.label = this.toggleButton?.querySelector("span");
        this.facetsWrap = scope.querySelector(".facets-wrap") || document.querySelector(".facets-wrap");
        this.sidebar = scope.querySelector(".page-layout-sidebar") || document.querySelector(".page-layout-sidebar");
        if (!this.toggleButton || !this.facetsWrap || !this.sidebar) return;

        this.onClick = () => (this.isExpanded() ? this.collapse() : this.expand());
        this.toggleButton.addEventListener("click", this.onClick);

        const state = this.readState();
        if (state == null || window.Shopify?.designMode) return;
        if (state === "collapsed") this.collapse();
        else this.expand();
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener("click", this.onClick);
      }

      isExpanded() {
        return this.facetsWrap.classList.contains("page-layout-with-sidebar");
      }

      collapse() {
        this.facetsWrap.classList.remove("page-layout-with-sidebar");
        this.sidebar.classList.add("is-collapsed");
        this.update("collapsed", this.dataset.labelShow);
      }

      expand() {
        this.facetsWrap.classList.add("page-layout-with-sidebar");
        this.sidebar.classList.remove("is-collapsed");
        this.update("expanded", this.dataset.labelHide);
      }

      update(state, label) {
        if (this.label && label) this.label.textContent = label;
        this.toggleButton.setAttribute("aria-expanded", String(state === "expanded"));
        if (window.Shopify?.designMode) return;
        try {
          localStorage.setItem(FiltersToggle.STORAGE_KEY, state);
        } catch (error) {
          // storage unavailable – state just isn't remembered
        }
      }

      readState() {
        try {
          return localStorage.getItem(FiltersToggle.STORAGE_KEY);
        } catch (error) {
          return null;
        }
      }
    }
  );
}
